import { faEdit, faEye, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";
import "../styles/date_popup.css";

const MySwal = withReactContent(Swal2);

const ChecklistReport = (props) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [users, setUsers] = useState([]);
  const [listClear, setListClear] = useState([]);
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [user, setUser] = useState("");
  const [userCheck, setUserCheck] = useState("");
  const [filter, setFilter] = useState(false);
  const [expand, setExpand] = useState("");

  const checkFailures = (chck, chck2) => {
    var i = 0;
    chck.map((el) => {
      if (chck2.filter((ep) => ep.question === el.question).length > 0) {
        if (
          chck2.filter((ep) => ep.question === el.question)[0].result === false
        ) {
          ++i;
        }
      }
    });
    return i;
  };

  const fetchList = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getChecklistReport", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.map((el) => {
          try {
            var chck = JSON.parse(el.checklist);
            var chck2 = JSON.parse(el.checklist2);
            var note1 = el.checklist4;
            var note2 = el.checklist5;
            var note3 = el.checklist3;
            var note4 = el.checklist6;
            var newR = {
              clientId: el.id_old,
              clientName: el.petitioner.replaceAll("  ", ""),
              checklist: chck,
              check: chck2,
              date: el.checklist_date,
              filterMonth: el.filterMonth,
              filterYear: el.filterYear,
              responsible: el.praw_pozew,
              checker: el.praw_spr_pozew,
              //failures: checkFailures(chck, chck2),
              failures: chck2.filter((el) => el.result !== "true").length,
              success: chck2.filter((el) => el.result === "true").length,
              noteSpr: note1,
              noteSpor: note2,
              noteFin: note3,
              noteZad: note4,
            };
            arr.push(newR);
          } catch (err) {}
        });

        setList(arr);
        setListClear(arr);
        fetchUsers();
      })
      .catch((error) => {
        fetchUsers();
      });
  };

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.map((el) => {
          var newR = {
            name: el.name,
            mail: el.mail,
          };
          arr.push(newR);
        });
        setUsers(arr);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchList();
  };

  useEffect(() => {
    getData();
  }, []);

  const getFilteredList = () => {
    var arr = listClear;
    if (month) {
      arr = arr.filter((el) => +el.filterMonth === +month);
    }
    if (year) {
      arr = arr.filter((el) => +el.filterYear === +year);
    }
    if (user) {
      arr = arr.filter((el) => el.responsible === user);
    }
    if (userCheck) {
      arr = arr.filter((el) => el.checker === userCheck);
    }
    setList(arr);
  };

  const clearFilters = () => {
    setMonth(new Date().getMonth() + 1);
    setYear(new Date().getFullYear());
    setUser("");
    setUserCheck("");
    setList(listClear);
  };

  return (
    <>
      <div className="mainContainerDatePopUp">
        {loading ? (
          <Loading id="popUpLoading" />
        ) : (
          <>
            <div className="closeButtonAP">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  width: "60%",
                }}
              >
                <div style={{ width: "45%", textAlign: "left" }}>
                  <p
                    style={{
                      margin: "0",
                      marginBottom: "10px",
                      fontWeight: "600",
                      fontSize: ".8vw",
                      paddingLeft: "20px",
                    }}
                  >
                    miesiąc
                  </p>
                  <input
                    type="number"
                    style={{
                      width: "100%",
                      padding: "0px 10px",
                      boxSizing: "border-box",
                    }}
                    value={month}
                    onChange={(e) => setMonth(+e.target.value)}
                  />
                </div>
                <div style={{ width: "45%", textAlign: "left" }}>
                  <p
                    style={{
                      margin: "0",
                      marginBottom: "10px",
                      fontWeight: "600",
                      fontSize: ".8vw",
                      paddingLeft: "20px",
                    }}
                  >
                    rok
                  </p>
                  <input
                    type="number"
                    style={{
                      width: "100%",
                      padding: "0px 10px",
                      boxSizing: "border-box",
                    }}
                    value={year}
                    onChange={(e) => setYear(+e.target.value)}
                  />
                </div>
                <div style={{ width: "45%", textAlign: "left" }}>
                  <p
                    style={{
                      margin: "0",
                      marginBottom: "10px",
                      fontWeight: "600",
                      fontSize: ".8vw",
                      paddingLeft: "20px",
                    }}
                  >
                    pracownik
                  </p>
                  <select
                    style={{
                      width: "100%",
                      padding: "0px 10px",
                      boxSizing: "border-box",
                    }}
                    value={user}
                    onChange={(e) => setUser(e.target.value)}
                  >
                    {!user ? (
                      <option key={0} value={"0"}>
                        Wybierz...
                      </option>
                    ) : (
                      ""
                    )}
                    {users.map((el) => (
                      <option key={el.name} value={el.name}>
                        {el.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={{ width: "45%", textAlign: "left" }}>
                  <p
                    style={{
                      margin: "0",
                      marginBottom: "10px",
                      fontWeight: "600",
                      fontSize: ".8vw",
                      paddingLeft: "20px",
                    }}
                  >
                    pracownik sprawdzający
                  </p>
                  <select
                    style={{
                      width: "100%",
                      padding: "0px 10px",
                      boxSizing: "border-box",
                    }}
                    value={userCheck}
                    onChange={(e) => setUserCheck(e.target.value)}
                  >
                    {!userCheck ? (
                      <option key={0} value={"0"}>
                        Wybierz...
                      </option>
                    ) : (
                      ""
                    )}
                    {users.map((el) => (
                      <option key={el.name} value={el.name}>
                        {el.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div
                style={{
                  marginTop: "2vh",
                  display: "flex",
                  gap: "10px",
                }}
              >
                <button
                  style={{
                    backgroundColor: "#00bdce",
                    border: "none",
                    color: "white",
                    fontWeight: "600",
                    borderRadius: "15px",
                  }}
                  id="clientsFilterButton"
                  className="paymentMenuButton"
                  onClick={getFilteredList}
                >
                  Pokaż
                </button>
                <button
                  style={{
                    backgroundColor: "#00bdce",
                    border: "none",
                    color: "white",
                    fontWeight: "600",
                    borderRadius: "15px",
                  }}
                  id="clientsFilterButton"
                  className="paymentMenuButton"
                  onClick={clearFilters}
                >
                  WYCZyŚĆ
                </button>
              </div>
              <div
                style={{ marginTop: "5vh", fontSize: "1vw", padding: "10px" }}
              >
                <div style={{ padding: "2vh 0", fontSize: "1.5vw" }}>
                  <p style={{ margin: "0" }}>Ilość ankiet: {list.length}</p>
                  <p style={{ margin: "0" }}>
                    Ilość prawidłowych:{" "}
                    {list.filter((el) => el.failures === 0).length}
                  </p>
                  <p style={{ margin: "0" }}>
                    Ilość błędnych:{" "}
                    {list.filter((el) => el.failures > 0).length}
                  </p>
                </div>
                {list.map((el, index) => (
                  <>
                    <div
                      style={
                        el.failures === 0
                          ? {
                              width: "100%",
                              backgroundColor: "green",
                              color: "white",
                              padding: "3vw 1vh",
                              borderRadius: "15px",
                              marginTop: "2vh",
                            }
                          : {
                              width: "100%",
                              backgroundColor: "red",
                              color: "white",
                              padding: "3vh 1vw",
                              alignItems: "center",
                              borderRadius: "15px",
                              marginTop: "2vh",
                            }
                      }
                    >
                      <div
                        style={
                          //el.checklist.length === el.success
                          el.failures === 0
                            ? {
                                color: "white",
                                padding: "3vw 1vh",

                                display: "flex",
                                gap: "10px",
                                alignItems: "center",
                                marginTop: "2vh",
                              }
                            : {
                                color: "white",
                                padding: "3vh 1vw",
                                borderRadius: "15px",
                                display: "flex",
                                gap: "10px",
                                alignItems: "center",
                                marginTop: "2vh",
                              }
                        }
                      >
                        <div
                          style={{
                            width: "15%",
                          }}
                        >
                          {el.clientName}
                        </div>
                        <div
                          style={{
                            borderLeft: "1px solid black",
                            paddingLeft: "10px",
                            width: "15%",
                          }}
                        >
                          Sprawdzający: {el.checker}
                        </div>
                        <div
                          style={{
                            borderLeft: "1px solid black",
                            paddingLeft: "10px",
                            width: "15%",
                          }}
                        >
                          Sporządził: {el.responsible}
                        </div>
                        <div
                          style={{
                            borderLeft: "1px solid black",
                            paddingLeft: "10px",
                            width: "15%",
                          }}
                        >
                          Ilość pytań: {el.checklist.length}
                        </div>
                        <div
                          style={{
                            borderLeft: "1px solid black",
                            paddingLeft: "10px",
                            width: "15%",
                          }}
                        >
                          Ilość prawidłowych: {el.success}
                        </div>
                        <div
                          style={{
                            borderLeft: "1px solid black",
                            paddingLeft: "10px",
                            width: "15%",
                          }}
                        >
                          Ilość błędów: {el.failures}
                        </div>
                        <div
                          style={{
                            borderLeft: "1px solid black",
                            paddingLeft: "10px",
                            width: "10%",
                            textAlign: "center",
                          }}
                        >
                          <button
                            style={{
                              backgroundColor: "white",
                              border: "none",
                              color: "black",
                              fontWeight: "600",
                              borderRadius: "15px",
                            }}
                            id="clientsFilterButton"
                            className="paymentMenuButton"
                            onClick={
                              expand === index
                                ? () => setExpand("")
                                : () => setExpand(index)
                            }
                          >
                            {expand === index ? "Zwiń" : "Pokaż"}
                          </button>
                        </div>
                      </div>
                      <div style={{ display: "flex", gap: "20px" }}>
                        <div>
                          <p>Notatka - sporządzający</p>
                          <p>{el.noteSpor ? el.noteSpor : "brak danych"}</p>
                        </div>
                        <div>
                          <p>Notatka - sprawdzający</p>
                          <p>{el.noteSpr ? el.noteSpr : "brak danych"}</p>
                        </div>
                        <div>
                          <p>Notatka - zadanie</p>
                          <p>{el.noteZad ? el.noteZad : "brak danych"}</p>
                        </div>
                        <div>
                          <p>Notatka - finalne sprawdzenie</p>
                          <p>{el.noteFin ? el.noteFin : "brak danych"}</p>
                        </div>
                      </div>
                    </div>
                    {expand === index ? (
                      <>
                        <div style={{ marginTop: "1vh" }}>
                          {el.checklist.map((eq) => (
                            <>
                              <div style={{ display: "flex", gap: "10px" }}>
                                <div
                                  style={{
                                    paddingLeft: "10px",
                                    width: "50%",
                                  }}
                                >
                                  Pytanie: {eq.question}
                                </div>
                                <div
                                  style={{
                                    borderLeft: "1px solid black",
                                    paddingLeft: "10px",
                                    width: "50%",
                                  }}
                                >
                                  Wynik sprawdzenia:{" "}
                                  {(
                                    el.check.filter(
                                      (ep) => ep.question === eq.question
                                    ).length > 0
                                      ? el.check.filter(
                                          (ep) => ep.question === eq.question
                                        )[0].result
                                      : false
                                  ) ? (
                                    <span
                                      style={{
                                        color: "green",
                                        fontWeight: "600",
                                      }}
                                    >
                                      DOBRZE
                                    </span>
                                  ) : (
                                    <span
                                      style={{
                                        color: "red",
                                        fontWeight: "600",
                                      }}
                                    >
                                      ŹLE
                                    </span>
                                  )}
                                </div>
                              </div>
                            </>
                          ))}
                        </div>{" "}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ChecklistReport;
